import React from 'react';
import { renderIcon } from '../../utils/iconRenderer';
import { FaMoon, FaSun, FaLock, FaDoorOpen } from 'react-icons/fa';

const SettingsModule = ({ theme, toggleTheme, onLogout }) => {
    return (
        <div className="content-section fade-in">
            <div className="content-header">
                <h2 className="content-title">Admin Settings</h2>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '24px' }}>
                <div className="table-container" style={{ padding: '24px' }}>
                    <h3 style={{ marginBottom: '20px', fontSize: '18px' }}>Appearance</h3>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <span style={{ fontWeight: 600 }}>Dark Mode</span>
                            <button className="theme-toggle" onClick={toggleTheme} style={{ width: '40px', height: '40px', borderRadius: '10px' }}>
                                {theme === 'light' ? <FaMoon /> : <FaSun />}
                            </button>
                        </div>
                        <div style={{ fontSize: '14px', color: 'var(--text-secondary)' }}>
                            Current theme: {theme.charAt(0).toUpperCase() + theme.slice(1)}
                        </div>
                    </div>
                </div>

                <div className="table-container" style={{ padding: '24px' }}>
                    <h3 style={{ marginBottom: '20px', fontSize: '18px' }}>System</h3>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                        <button className="btn-save" style={{ width: '100%' }}>
                            Save Configuration
                        </button>
                        <button
                            className="btn-save"
                            style={{ width: '100%', background: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)', boxShadow: '0 4px 12px rgba(239, 68, 68, 0.3)' }}
                            onClick={onLogout}
                        >
                            Log Out Session
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SettingsModule;
